export var ControlTypes;
(function (ControlTypes) {
    ControlTypes[ControlTypes["Control"] = 0] = "Control";
    ControlTypes[ControlTypes["Group"] = 1] = "Group";
    ControlTypes[ControlTypes["Array"] = 2] = "Array";
})(ControlTypes || (ControlTypes = {}));
//# sourceMappingURL=%D1%81ontrol-types.js.map